import { jsx } from "react/jsx-runtime";
import {
  getTokens,
  getVariable,
  getVariableValue,
  useProps,
  useTheme
} from "@tamagui/core";
function themed(Component) {
  const wrapped = (propsIn) => {
    const props = useProps(propsIn);
    const theme = useTheme();
    const defaultColor = props.color ?? "black";
    const color = getVariable(
      (defaultColor in theme ? theme[defaultColor] : void 0) || props.color || (!props.disableTheme ? theme.color : null) || "#000"
    );
    const size = typeof props.size === "string" ? getVariableValue(getTokens().size[props.size] || props.size) : props.size;
    const strokeWidth = typeof props.strokeWidth === "string" ? getVariableValue(getTokens().size[props.strokeWidth] || props.strokeWidth) : props.strokeWidth ?? "2";
    return /* @__PURE__ */ jsx(Component, { ...props, color, size, strokeWidth });
  };
  return wrapped;
}
export {
  themed
};
//# sourceMappingURL=themed.js.map
